import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  {
    title: "Acceptance of Terms",
    body: [
      "These Terms & Conditions govern your use of www.carltonwellness.com and the services offered by Carlton Wellness Center, an EBG Group company. By accessing the website, booking an assessment or purchasing a membership, you agree to these terms.",
    ],
  },
  {
    title: "Our Services",
    body: [
      "Carlton Wellness Center provides protocol-led wellness services including prevention and longevity programs, rehab and recovery, mental wellbeing, slimming and metabolic reset, anti-ageing and Kayakalp, skin, hair and body wellness, nutrition guidance and community wellness programs. Services are delivered at our centers by qualified doctors, therapists and nutritionists.",
    ],
  },
  {
    title: "Not Medical Treatment",
    body: [
      "Our programs support wellness, prevention and lifestyle health. They are not a substitute for emergency medical care, diagnosis or treatment of medical conditions. Always consult your physician before beginning any new wellness program, especially if you have an existing medical condition.",
    ],
  },
  {
    title: "Bookings & Assessments",
    body: [
      "Assessment bookings made through the website are requests and are confirmed by our team by phone or email. We reserve the right to reschedule appointments with prior notice. Please arrive on time; late arrivals may result in shortened sessions.",
    ],
  },
  {
    title: "Memberships & Payments",
    body: [
      "Membership tiers, pricing, inclusions and validity are communicated at the center at the time of purchase. Memberships are personal and non-transferable unless expressly agreed in writing. Refunds and freezes are governed by the membership agreement signed at purchase.",
    ],
  },
  {
    title: "Member Conduct",
    body: [
      "To preserve a calm, private and hygienic environment, members and guests agree to follow center guidelines, respect staff and other members, and use equipment and facilities responsibly. We may refuse or discontinue service in cases of misconduct.",
    ],
  },
  {
    title: "Franchise Enquiries",
    body: [
      "Franchise-related information on this website is indicative and does not constitute an offer. Any partnership is subject to evaluation, due diligence and a definitive agreement executed between the parties.",
    ],
  },
  {
    title: "Intellectual Property",
    body: [
      "All content on this website — including the Carlton Wellness Center name, logo, text, images and design — is owned by or licensed to Carlton Wellness Center and may not be reproduced without prior written permission.",
    ],
  },
  {
    title: "Limitation of Liability",
    body: [
      "To the maximum extent permitted by law, Carlton Wellness Center shall not be liable for indirect or consequential losses arising from use of the website. Participation in physical programs is undertaken with awareness of your own health condition and the guidance provided by our experts.",
    ],
  },
  {
    title: "Governing Law",
    body: [
      "These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts of Hyderabad, Telangana.",
    ],
  },
];

export default function Terms() {
  return (
    <LegalPage
      testid="terms-page"
      crumb="Terms & Conditions"
      line1="Clear Terms."
      line2="Honest Service."
      updated="June 2026"
      sections={SECTIONS}
    />
  );
}
